import React from 'react';
import styles from './infoDisplaySection.module.scss';
import i18n from 'i18n';
import classNames from 'classnames/bind';
import IconWithTooltip from 'components/IconWithTooltip/IconWithTooltip';
import { faQuestionCircle } from '@fortawesome/free-regular-svg-icons';

const cx = classNames.bind(styles);

export interface InfoDisplaySectionProps {
  data: ({ label: string; value: any; extra?: any } & { className?: string })[];
  title?: string;
  columnWidth?: number;
  className?: string;
}

export const InfoDisplaySectionTitle: React.FC<{
  title: string;
  hint?: string;
  className?: string;
}> = ({ title, hint, className }) => {
  return (
    <div className={cx(styles.titleContainer, className)}>
      {title !== '' && <span className={styles.title}>{title}</span>}
      {hint && (
        <IconWithTooltip
          icon={faQuestionCircle}
          tooltipProps={{
            id: `${title}-tooltip`,
            tooltip: hint
          }}
        />
      )}
      <span className={styles.sepline} />
    </div>
  );
};

export const InfoDisplaySection: React.FC<InfoDisplaySectionProps> = (
  props
) => {
  const classNames = cx.bind(styles);

  const renderData = () => {
    if (props.data.length === 0) {
      return (
        <div className={styles.field}>
          <div className={styles.fieldLabel}>
            {i18n.t('common.labels.noData')}
          </div>
        </div>
      );
    }
    return props.data.map((data) => {
      const title = data.label;
      const value = data.value;
      const hint = data.extra;
      const valueClassName = classNames('fieldValue', data.className, {
        hint: !!hint
      });

      return (
        <div className={styles.field} key={data.label}>
          <div className={styles.fieldLabel}>{title}</div>
          <div className={valueClassName}>{value}</div>
          <div className={styles.fieldHint}>{hint}</div>
        </div>
      );
    });
  };

  const sectionClassName = classNames(styles.section, props.className);

  return (
    <div className={sectionClassName}>
      {props.title !== undefined && (
        <InfoDisplaySectionTitle title={props.title} />
      )}
      <div
        className={styles.content}
        style={{
          gridTemplateColumns: `repeat(auto-fill, ${props.columnWidth ? props.columnWidth : 200}px)`
        }}
      >
        {renderData()}
      </div>
    </div>
  );
};
